import React from 'react';

import { Box, Typography } from '@mui/material';

import OfferMetricsForm, { OfferMetricsFormData } from './OfferMetricsForm';
import OfferMetricsGrid from './OfferMetricsGrid';

type OfferMetricsTabProps = {
  // Data and loading states
  offerMetricsData: Array<any>;
  offerMetricsLoading: boolean;
  offerMetricsTotal: number;
  offerMetricsPage: number;
  offerMetricsPageSize: number;

  // Filters
  offerMetricsFilters: OfferMetricsFormData;

  // Handlers
  handleOfferMetricsFormSubmit: (data: OfferMetricsFormData) => void;
  handleOfferMetricsPageChange: (page: number, pageSize: number) => void;
  handleOfferMetricsSortChange: (sortBy: string, sortOrder: 'asc' | 'desc') => void;
};

export default function OfferMetricsTab({
  offerMetricsData,
  offerMetricsLoading,
  offerMetricsTotal,
  offerMetricsPage,
  offerMetricsPageSize,
  offerMetricsFilters,
  handleOfferMetricsFormSubmit,
  handleOfferMetricsPageChange,
  handleOfferMetricsSortChange,
}: OfferMetricsTabProps) {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Offer Metrics
      </Typography>
      <Box mb={3}>
        <OfferMetricsForm
          onSubmit={handleOfferMetricsFormSubmit}
          isLoading={offerMetricsLoading}
          defaultValues={offerMetricsFilters}
        />
      </Box>
      <OfferMetricsGrid
        data={offerMetricsData}
        isLoading={offerMetricsLoading}
        totalCount={offerMetricsTotal}
        page={offerMetricsPage}
        pageSize={offerMetricsPageSize}
        onPageChange={handleOfferMetricsPageChange}
        onSortChange={handleOfferMetricsSortChange}
        currentSortBy={offerMetricsFilters.sortBy}
        currentSortOrder={offerMetricsFilters.sortOrder}
      />
    </>
  );
}
